import { Link } from 'react-router-dom';
import { useGlobal } from '../../state';
import { Info } from '../message';

export const NagToPay = () => {
  const { user } = useGlobal();

  if (user?.level != 'free') {
    return null;
  }

  return (
    <div>
      <Info>
        Free accounts are limited to 10 results per scrape.{' '}
        <Link to="/billing" style={{ color: 'unset', textDecoration: 'underline' }}>
          Buy at least $1 of credits to see full results &raquo;
        </Link>
      </Info>
    </div>
  );
};
